import _ from "lodash";
import { useCallback } from "react";
import {
  actions,
  ActionType,
  Hooks,
  TableInstance,
  TableState,
  useRowSelect,
} from "react-table";

actions.selectAll = "selectAll";

const useInstance = <T extends object>(instance: TableInstance<T>) => {
  const { dispatch } = instance;
  const toggleAll = useCallback(
    (value: T) => dispatch({ type: actions.selectAll, value }),
    [dispatch]
  );
  Object.assign(instance, {
    toggleAll,
  });
};

const reducer = <T extends object>(
  state: TableState<T>,
  action: ActionType,
  _previousState: TableState<T> | undefined,
  instance: TableInstance<T> | undefined
) => {
  const { value: setAll } = action;
  switch (action.type) {
    case actions.resetFilters:
    case actions.setFilter:
    case actions.setAllFilters:
    case actions.resetGlobalFilter:
    case actions.setGlobalFilter:
      return {
        ...state,
        selectedRowIds: {},
      };
    case actions.selectAll:
      // eslint-disable-next-line no-case-declarations
      const selectedRowIds: Record<string, boolean> = setAll
        ? _(instance?.allIds)
            .map((id) => [id, true])
            .fromPairs()
            .value()
        : {};
      return {
        ...state,
        selectedRowIds,
      };
    default:
      return undefined;
  }
};

/**
 * Wrapped version of useRowSelect, which also supports selection across
 * multiple pages.
 */
const useRowSelectPatched = <T extends object>(hooks: Hooks<T>) => {
  useRowSelect(hooks);
  hooks.stateReducers.push(reducer);
  hooks.useInstance.push(useInstance);
};
useRowSelectPatched.pluginName = "useRowSelect";

export default useRowSelectPatched;
